export const navOptions = [
  {
    name: "Dashboard",
    label: "Dashboard",
    selectedSvg: "dashboardSelected",
    svg: "dashboard",
    roles: ["SuperAdmin", "Admin"],
  },
  {
    name: "Sites",
    label: "Sites",
    selectedSvg: "SitesIcon",
    svg: "SitesIcon",
    roles: ["SuperAdmin"],
  },
  {
    name: "Users",
    label: "Users",
    selectedSvg: "UsersIcon",
    svg: "UsersIcon",
    roles: ["SuperAdmin", "Admin"],
  },
  {
    name: "Account",
    label: "Account",
    selectedSvg: "AccountIcon",
    svg: "AccountIcon",
    roles: ["Radiologist", "Admin", "SuperAdmin"],
  },
  {
    name: "Settings",
    label: "Settings",
    selectedSvg: "SettingsIcon",
    svg: "SettingsIcon",
    roles: ["Radiologist", "Admin", "SuperAdmin"],
  },
];

